import { Music } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangChiTietBaiNhac } from './pages/TrangChiTietBaiNhac.js';
import { TrangKhoNhac } from './pages/TrangKhoNhac.js';

const music: KhaiBaoModule = {
  id: 'music',
  nav: {
    group: 'NỘI DUNG',
    label: 'Kho nhạc',
    icon: Music,
    order: 3,
    permission: 'music',
    to: '/kho-nhac',
  },
  routes: [
    {
      path: '/kho-nhac',
      element: createElement(TrangKhoNhac),
      permission: { module: 'music', level: 'view' },
    },
    {
      path: '/kho-nhac/:id',
      element: createElement(TrangChiTietBaiNhac),
      permission: { module: 'music', level: 'view' },
    },
  ],
};

export default music;
